import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=2ac04018"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"
import style0 from "./Faq.vue?vue&type=style&index=0&id=2ac04018&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Picture: require('/vercel/path0/components/elements/Picture.vue').default,Richtext: require('/vercel/path0/components/elements/Richtext.vue').default,Accordion: require('/vercel/path0/components/elements/AccordionGroup/Accordion.vue').default,AccordionGroup: require('/vercel/path0/components/elements/AccordionGroup/index.vue').default,Section: require('/vercel/path0/components/elements/Section.vue').default})
